import ddt from '@wix/da-ddt';
export var GallectionType;
(function(GallectionType) {
    GallectionType["GALLERY"] = 'gallery';
    GallectionType["COLLECTION"] = 'collection';
    GallectionType["PRIVATE_COLLECTION"] = 'private_collection';
    GallectionType["STASH"] = 'stash';
})(GallectionType || (GallectionType = {}));
export var GallectionResourceType;
(function(GallectionResourceType) {
    GallectionResourceType[GallectionResourceType["GALLERY"] = 20] = "GALLERY";
    GallectionResourceType[GallectionResourceType["COLLECTION"] = 21] = "COLLECTION";
    GallectionResourceType[GallectionResourceType["STASH"] = 59] = "STASH";
})(GallectionResourceType || (GallectionResourceType = {}));
export function gallectionTypeToResourceType(// accomodate type being defined as a plain string in PapiGallection
typeString) {
    switch(typeString){
        case GallectionType.GALLERY:
            return GallectionResourceType.GALLERY;
        case GallectionType.COLLECTION:
            return GallectionResourceType.COLLECTION;
        case GallectionType.STASH:
            return GallectionResourceType.STASH;
        default:
            ddt.error(`unknown GallectionType: ${typeString}`);
            return undefined;
    }
}
export var PremiumFolderType;
(function(PremiumFolderType) {
    PremiumFolderType["Watchers"] = 'watchers';
    PremiumFolderType["Paid"] = 'paid';
})(PremiumFolderType || (PremiumFolderType = {}));
